import { render, staticRenderFns } from "./SectorList.vue?vue&type=template&id=e6ba7988"
import script from "./SectorList.vue?vue&type=script&lang=js"
export * from "./SectorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports